export const sources = {
	webp: "__VITE_ASSET__6kssa3xCT2YlMpIbbRNP$Q__ 400w, __VITE_ASSET__cLZLOsSELI_GmwKcVOKKRw__ 800w"
};
export const img = {
	src: "__VITE_ASSET__cLZLOsSELI_GmwKcVOKKRw__",
	w: 800,
	h: 1067
};
export default {
	sources: sources,
	img: img
};
